export enum FileTypeEnum {
	TextPlain = 'text/plain',
	ImageSvg = 'image/svg',
	ImageSvgXml = 'image/svg+xml',
	ImagePng = 'image/png',
	ImageJpg = 'image/jpg',
	ImageJpeg = 'image/jpeg',
	ImageTxt = 'image/txt',
}
